const showAlert = (node, message) => {
  const error = global.document.createElement('p');
  error.classList.add('text-danger', 'js-card-error-message', 'small', 'mb-1');
  error.textContent = message;
  node.parentNode.parentNode.insertBefore(error, node.parentNode);
};

function enableSubmitButton() {
  $.rails.enableElement($('#js-btn-inject-gmo'));
  $('#js-btn-inject-gmo').removeAttr('disabled');
}

const getExpMonthValue = () => {
  const exp       = document.querySelector('.js-credit-card-form [name="exp"]');
  const expMonth  = document.querySelector('.js-credit-card-form [name="exp_month"]');
  if (exp) {
    const splitedExpValues = exp.value.split('/');
    if (splitedExpValues.length >= 1) {
      return splitedExpValues[0].replace(/ /g, '');
    }
    return '';
  } else if (expMonth) {
    return expMonth.value;
  }
  console.error('exp or exp_month is not found.');
  return '';
};

const getExpYearValue = () => {
  const exp       = document.querySelector('.js-credit-card-form [name="exp"]');
  const expYear  = document.querySelector('.js-credit-card-form [name="exp_year"]');
  if (exp) {
    const splitedExpValues = exp.value.split('/');
    if (splitedExpValues.length >= 2) {
      const splitedExpYear = splitedExpValues[1].replace(/ /g, '');
      if (splitedExpYear.length === 4) {
        // 4桁(20xx)の場合
        return splitedExpYear;
      } else if (splitedExpYear.length === 2) {
        // 2桁の場合
        return `20${splitedExpYear}`;
      }
      return '';
    }
    return '';
  } else if (expYear) {
    return expYear.value;
  }
  console.error('exp or exp_year is not found.');
  return '';
};

const getNumberValue = () => {
  const number = document.querySelector('.js-credit-card-form [name="number"]');
  return number.value.replace(/ /g, '');
};

const getTrimmedValue = (elementId) => {
  const element = document.getElementById(elementId);
  return element ? element.value.replace(/ /g, '') : '';
};

const getHolderValue = () => getTrimmedValue('card_holder');
const getCvcValue = () => getTrimmedValue('cvc');

// ホスト名に基づいてエラーメッセージを取得する関数
const getErrorMessage = (hostname, messages) => {
  if (hostname.startsWith('tw')) return messages.tw;
  if (hostname.startsWith('hk')) return messages.hk;
  if (hostname.startsWith('staging') || hostname.startsWith('p')) return messages.cn;
  if (hostname.startsWith('www')) return messages.en;
  return messages.ja;
};

// すべての必要なカード情報が提供されているかを確認するメソッド
const completeCardInformation = () => {
  const hostname = window.location.hostname;

  const cardErrorMessage = {
    ja: 'カード情報を全部入力してください',
    tw: '請填寫所有信用卡資訊',
    hk: '請填寫所有信用卡資訊',
    cn: '请填写所有信用卡信息',
    en: 'Please enter all card information'
  };

  const completeCardInfoErrorMessage = getErrorMessage(hostname, cardErrorMessage);

  const isCardInfoComplete = [
    getExpMonthValue(),
    getExpYearValue(),
    getHolderValue(),
    getCvcValue(),
  ].every(value => value !== '');

  if (!isCardInfoComplete) {
    alert(completeCardInfoErrorMessage);
    return false;
  }
  return true;
};

const fillErrorEl = (errorEl, msg) => {
  if (!errorEl) return;
  errorEl.innerHTML = '';

  const icon = document.createElement('i');
  icon.classList.add('fas', 'fa-exclamation-circle', 'mr-1');

  const errorMsgSpan = document.createElement('span');
  errorMsgSpan.textContent = msg;

  errorEl.append(icon, errorMsgSpan);
};

const getSubdomain = () => {
  const hostname = window.location.hostname;
  if (hostname.includes('cn')) return 'cn';
  return hostname.split('.')[0];
};

// 条約同意チェック
const checkServiceAgreement = () => {
  const errorMsgTranslations = {
    termsShouldBeAgreed: {
      'jp': '購入するためには、本規約にご同意して頂く必要がございます',
      'tw': '您必須同意各項條款方可購買本商品',
      'hk': '您必須同意各項條款方可購買本商品',
      'cn': '您必须同意各项条款方可购买本商品',
      'www': 'To continue with purchase, you must agree to these terms.',
      'au': 'To continue with purchase, you must agree to these terms.',
    }
  };

  const subdomain = getSubdomain();
  const message = errorMsgTranslations.termsShouldBeAgreed[subdomain]

  const termsCheckbox = document.querySelector('#terms_of_service_agreement');
  const errorEl = document.querySelector('#terms_of_service_agreement_error');

  // 予約連携のクレカ新規登録画面にはサービス同意チェックボックスがないためnull制御をかける
  if (termsCheckbox !== null && !termsCheckbox.checked) {
    fillErrorEl(errorEl, message);
    return false;
  }

  if (errorEl) errorEl.innerHTML = '';
  return true;
}

// Asuka不正利用関連のカードスコア判定結果をチェックする関数
const scoreValue = () => {
  return new Promise((resolve, reject) => {
    const hostname = window.location.hostname;

    const asukaCardScoreErrorMessage = {
      ja: 'このカードはご利用できません',
      tw: '不可使用该信用卡',
      hk: '不可使用该信用卡',
      cn: '不可使用该信用卡',
      en: 'This credit card is not usable'
    };

    const asukaCardScoreErrorMessageByLocale = getErrorMessage(hostname, asukaCardScoreErrorMessage);

    if (typeof aerosmith === 'undefined') {
      alert(asukaCardScoreErrorMessageByLocale);
      reject(false);
      return;
    }

    aerosmith.checkScore(
      (reason) => {
        if (['LRT', 'BIAT', 'MM'].includes(reason)) {
          resolve(true);  // ASUKAの不正利用リスク判定通過してからGMOのカード登録処理を進む
        } else {
          alert(asukaCardScoreErrorMessageByLocale);
          reject(false);
        }
      },
      () => {
        alert(asukaCardScoreErrorMessageByLocale);
        reject(false);
      }
    );
  });
};

const injectGmoAndSubmit = () => {
  const form = document.getElementById('order_form');
  const selectors = ['number', 'cvc', 'exp', 'exp_month', 'exp_year', 'name'];
  const [_number, cvc, _exp, _expMonth, _expYear, name] = selectors.map(name => document.querySelector(`.js-credit-card-form [name="${name}"]`));

  const gmoCard = {
    cardno: getNumberValue(),
    securiycode: cvc.value,
    expire: getExpYearValue() + getExpMonthValue(),
    holdername: name.value,
  };

  const errorMessages = {
    ja: {
      100: 'カード番号を正しくご入力ください',
      101: 'カード番号を正しくご入力ください',
      102: 'カード番号は10-16桁でご入力ください',
      110: 'カードの有効期限を正しくご入力ください',
      111: 'カードの有効期限を正しくご入力ください',
      112: 'カードの有効期限を正しくご入力ください',
      113: 'カードの有効期限を正しくご入力ください',
      121: 'カードのセキュリティコードを正しくご入力ください',
      122: 'カードのセキュリティコードを正しくご入力ください（桁数エラー）',
      131: 'カード所有者名を正しくご入力ください',
      132: 'カード所有者名を正しくご入力ください'
    },
    tw: {
      100: '輸入正確的信用卡號碼。',
      101: '請輸入正確的信用卡號碼。',
      102: '請輸入10-16位數的信用卡號碼。',
      110: '請輸入正確的信用卡有效期限。',
      111: '請輸入正確的信用卡有效期限。',
      112: '請輸入正確的信用卡有效期限。',
      113: '請輸入正確的信用卡有效期限。',
      121: '請輸入正確的信用卡安全碼。',
      122: '請輸入正確的信用卡安全碼。（位數錯誤）',
      131: '請輸入正確的持卡人姓名。',
      132: '請輸入正確的持卡人姓名。'
    },
    hk: {
      100: '輸入正確的信用卡號碼。',
      101: '請輸入正確的信用卡號碼。',
      102: '請輸入10-16位數的信用卡號碼。',
      110: '請輸入正確的信用卡有效期限。',
      111: '請輸入正確的信用卡有效期限。',
      112: '請輸入正確的信用卡有效期限。',
      113: '請輸入正確的信用卡有效期限。',
      121: '請輸入正確的信用卡安全碼。',
      122: '請輸入正確的信用卡安全碼。（位數錯誤）',
      131: '請輸入正確的持卡人姓名。',
      132: '請輸入正確的持卡人姓名。'
    },
    cn: {
      100: '请填写正确的信用卡号',
      101: '请填写正确的信用卡号',
      102: '请填写10-16位的信用卡号',
      110: '请填写正确的信用卡有效期',
      111: '请填写正确的信用卡有效期',
      112: '请填写正确的信用卡有效期',
      113: '请填写正确的信用卡有效期',
      121: '请填写正确的信用卡安全码',
      122: '请填写正确的信用卡安全码（位数错误）',
      131: '请填写正确的信用卡持卡人姓名',
      132: '请填写正确的信用卡持卡人姓名',
    },
    en: {
      100: 'Enter the correct credit card number',
      101: 'Enter the correct credit card number',
      102: 'Enter the card number, between 10 and 16 digits',
      110: 'Enter the correct card expiration date',
      111: 'Enter the correct card expiration date',
      112: 'Enter the correct card expiration date',
      113: 'Enter the correct card expiration date',
      121: 'Enter the correct card security code',
      122: 'Enter the correct card security code (digit error)',
      131: 'Enter the correct cardholder name',
      132: 'Enter the correct cardholder name'
    }
  };

  const hostname = window.location.hostname;

  let selectedErrorMessages;
  if (hostname.startsWith('tw')) {
    selectedErrorMessages = errorMessages.tw;
  } else if (hostname.startsWith('hk')) {
    selectedErrorMessages = errorMessages.hk;
  } else if (hostname.startsWith('staging') || hostname.startsWith('p')) {
    selectedErrorMessages = errorMessages.cn;
  } else if (hostname.startsWith('www')) {
    selectedErrorMessages = errorMessages.en;
  } else {
    selectedErrorMessages = errorMessages.ja;
  }

  if (typeof Multipayment !== 'undefined') {
    Multipayment.getToken(gmoCard, (gmoResponse) => {
      if (gmoResponse.resultCode === '000') {
        const gmoinput = document.createElement('input');
        gmoinput.type = 'hidden';
        gmoinput.name = 'gmo_card_token';
        gmoinput.setAttribute('value', gmoResponse.tokenObject.token);
        form.appendChild(gmoinput);
        document.getElementById('js-hidden-submit-btn-with-gmo-token').click();
        return gmoResponse.tokenObject.token;
      } else {
        const cardRegisterErrorMsg = selectedErrorMessages[gmoResponse.resultCode] || '不明なエラーが発生しました';
        enableSubmitButton();
        alert(cardRegisterErrorMsg);
        throw new Error(`Error when getting GMO token. GMO error code: ${gmoResponse.resultCode}`);
      }
    });
  }
};

function disableSubmitButton() {
  $.rails.disableElement($('#js-btn-inject-gmo'));
  $('#js-btn-inject-gmo').attr('disabled', 'disabled');
}

function disableEnterSubmit() {
  const inputFields = Array.from(document.querySelectorAll('input, select'));
  // テキストフィールドとセレクトでEnterキーを押した時にフォームがsubmitされるのを無効化
  inputFields.forEach((input) => {
    input.addEventListener('keypress', (e) => {
      if ((e.which && e.which === 13) || (e.keyCode && e.keyCode === 13)) {
        e.preventDefault();
        return false;
      }
      return true;
    });
  });
}

// Asuka不正利用検知サービスの仕様により、カード番号フォマットに合わせて、カード番号フォームより上6桁・下3桁を取得する
function truncateCreditCardNumber(creditCardNumber) {
  return `${creditCardNumber.slice(0, 6)}${creditCardNumber.slice(
    creditCardNumber.length - 3
  )}`;
};

// Asuka不正利用検知サービスの仕様により、カード有効期限フォマットに合わせて、有効期限を整形する
// 例：07, 2030 => 0730
function formatExpiry(month, year) {
  const formattedMonth = month ? month.padStart(2, "0") : "";
  const formattedYear = year ? year.slice(2) : "";
  return `${formattedMonth}${formattedYear}`;
}

// Asuka不正利用検知サービスの仕様に従い、カード有効期限のデータタイプを動的にselectで設定する
function populateSelectAndSetExpValueForAsuka(optionsArray, selectedValue) {
  const selectElement = document.getElementById('credit_card_exp');

  selectElement.innerHTML = '';

  optionsArray.forEach(optionValue => {
    const option = document.createElement('option');
    option.value = optionValue;
    option.textContent = optionValue;
    selectElement.appendChild(option);
  });

  selectElement.value = selectedValue;
}

// Asukaチェック済みかどうかをバックエンドで判定するためのkeyをセットする
function setAsukaScoreBaseKey() {
  const asukaScoreBaseKey = aerosmith.getScoreBaseKey()
  const form = document.getElementById('order_form');
  const asukaScoreBaseKeyInput = document.createElement('input');
  asukaScoreBaseKeyInput.type = 'hidden';
  asukaScoreBaseKeyInput.name = 'asuka_score_base_key';
  asukaScoreBaseKeyInput.value = asukaScoreBaseKey;
  form.appendChild(asukaScoreBaseKeyInput);
}

document.addEventListener('turbolinks:load', () => {
  const elements = {
    cardNumberInput: document.getElementById('card_number'),
    creditCardNumberForAsuka: document.getElementById('credit_card_number'),
    cardHolderInput: document.getElementById('card_holder'),
    creditCardHolderForAsuka: document.getElementById('credit_card_holder'),
    cardExpMonthSelect: document.getElementById('exp_month'),
    cardExpYearSelect: document.getElementById('exp_year'),
    cardExpDateForAsuka: document.getElementById('credit_card_exp')
  };

  function syncInput(source, target, transform = (val) => val) {
    if (source !== null) {

      source.addEventListener('input', () => {
        target.value = transform(source.value);
      });
    }
  }

  // クレカ有効期限を変更する際、selectタグを動的に更新してから、整形したクレカ有効期限をAsukaに送信する
  function updateExpiryDate() {
    const formattedExpDate = formatExpiry(elements.cardExpMonthSelect.value, elements.cardExpYearSelect.value);
    populateSelectAndSetExpValueForAsuka([formattedExpDate], formattedExpDate);
  }

  syncInput(elements.cardNumberInput, elements.creditCardNumberForAsuka, truncateCreditCardNumber);
  syncInput(elements.cardHolderInput, elements.creditCardHolderForAsuka);

  // クレカ有効期限を変更する際、月と年の両方の変更を監視しながら、動的にアップデートする
  if (elements.cardExpMonthSelect !== null && elements.cardExpYearSelect !== null) {
    elements.cardExpMonthSelect.addEventListener('input', updateExpiryDate);
    elements.cardExpYearSelect.addEventListener('input', updateExpiryDate);
  }

  if (typeof Multipayment !== 'undefined') {
    Multipayment.init(window.gon.gmoShopId);
  }
  const submitButton = document.querySelector('#js-btn-inject-gmo');
  const registerGmoForm = document.querySelector('.js-credit-card-form');

  if (submitButton == null || registerGmoForm == null) { return; }

  submitButton.addEventListener('click', async (e) => {
    e.preventDefault();
    disableSubmitButton();

    if (!completeCardInformation() || !checkServiceAgreement()) {
      enableSubmitButton();
      return;
    }

    try {
      await scoreValue();

      setAsukaScoreBaseKey();
      injectGmoAndSubmit();
    } catch (error) {
      enableSubmitButton();
    }
  });
});
